module.exports = __webpack_public_path__ + "static/media/landing_page_illustration.b3e23c5a.webp";